import React from "react";
import { jobOfferStatusTypes } from "../../../../models/candidate.model";
import { Container } from "./job-offer-status.styled";

import { Status } from "../../../../components/talent/components/feedback-status/feedback-status.styled";
import { t } from "i18next";
import { selectedSchema } from "../../../home-components/table/components/selected-status/selected-status.utils";


interface JobOfferStatusProps {
  status: jobOfferStatusTypes;
  isDetailed: boolean;
}

const JobOfferSchema = selectedSchema;

const JobOfferStatus: React.FC<JobOfferStatusProps> = ({
  status,
  isDetailed,
}) => {
  const statusSchema = JobOfferSchema[status.toLowerCase()];
  return (
    <Container>
      <div>
        <Status
          color={statusSchema.color}
        >
          <p>{t(statusSchema.title)}</p>
        </Status>
        {isDetailed && statusSchema.description && <p>{t(statusSchema.description)}</p>}
      </div>
    </Container>
  );
};

export default JobOfferStatus;
